import { Outlet, RouteObject } from 'react-router-dom';
import { Box } from '@mui/material';
import { MinimalAuth0Provider } from '../auth0-provider';
import { DemoNav } from '../components/layout/DemoNav';
import DemoNotesView, { DemoNotesLoader } from '../Views/DemoNotesView';
import NoteViewRevamp from '../Views/NoteViewRevamp';
import { DemoNoteLoader } from '../loaders/NoteLoader';

export const demoRoutes: RouteObject[] = [
  {
    path: '/demo/',
    element: (
      <MinimalAuth0Provider>
        <Box
          sx={{
            height: '100dvh',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <DemoNav />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </Box>
      </MinimalAuth0Provider>
    ),
    children: [
      {
        path: '/demo/',
        element: <DemoNotesView />,
        loader: DemoNotesLoader,
      },
      {
        path: '/demo/:noteId',
        element: <NoteViewRevamp demoMode={true} />,
        loader: DemoNoteLoader,
      },
    ],
  },
];
